var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "#F1F2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5646 13.2367H10.8198L11.9111 6.7832H13.6558L12.5646 13.2367Z",
    fill: "#1A1F71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8886 6.94077C18.5445 6.81019 17.9986 6.66602 17.3237 6.66602C15.6007 6.66602 14.3873 7.54475 14.3799 8.80106C14.3656 9.72797 15.2486 10.2428 15.909 10.5519C16.5841 10.8677 16.8135 11.0738 16.8135 11.3553C16.8067 11.7877 16.2681 11.9869 15.7657 11.9869C15.0691 11.9869 14.6959 11.8842 14.1287 11.6437L13.8989 11.5405L13.6548 12.9892C14.064 13.1675 14.8179 13.3257 15.6007 13.3327C17.4314 13.3327 18.6233 12.4675 18.6374 11.1287C18.6444 10.3941 18.1781 9.83118 17.1728 9.37119C16.5626 9.07591 16.1889 8.8768 16.1889 8.57468C16.196 8.30002 16.505 8.01869 17.1938 8.01869C17.761 8.00492 18.1778 8.13531 18.4935 8.2658L18.6513 8.33432L18.8886 6.94077V6.94077Z",
    fill: "#1A1F71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2082 10.9505C21.3519 10.5797 21.9048 9.14482 21.9048 9.14482C21.8976 9.1586 22.0482 8.76723 22.1344 8.52698L22.2563 9.08305C22.2563 9.08305 22.5867 10.6278 22.6585 10.9505C22.3858 10.9505 21.5529 10.9505 21.2082 10.9505ZM23.3619 6.7832H22.0123C21.5962 6.7832 21.28 6.89982 21.1004 7.31865L18.5088 13.2366H20.3395C20.3395 13.2366 20.6409 12.4401 20.7057 12.2686C20.9065 12.2686 22.6875 12.2686 22.9458 12.2686C22.9959 12.4951 23.154 13.2366 23.154 13.2366H24.7695L23.3619 6.7832V6.7832Z",
    fill: "#1A1F71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36285 6.7832L7.65415 11.1839L7.46743 10.2914C7.15153 9.26153 6.16079 8.14263 5.05518 7.58629L6.62028 13.2299H8.46533L11.2078 6.7832H9.36285V6.7832Z",
    fill: "#1A1F71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06683 6.7832H3.25968L3.23096 6.9136C5.42072 7.44914 6.87095 8.74004 7.46679 10.2916L6.85654 7.32568C6.75608 6.91351 6.44733 6.7968 6.06683 6.7832Z",
    fill: "#1A1F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visa-card.0fba909844656420fb23d4b9ef535597.svg";
export { ForwardRef as ReactComponent };